/**
 * Rótulo padrão de unidade de negócio nas telas: "cod_unidade - nome_unidade".
 * Cai para o que existir quando um dos dois campos estiver vazio.
 */
export function formatUnidadeLabel(unidade) {
    if (!unidade) return '';
    const cod = unidade.cod_unidade != null ? String(unidade.cod_unidade).trim() : '';
    const nome = unidade.descricao_unidade != null ? String(unidade.descricao_unidade).trim() : '';
    if (cod && nome) return `${cod} - ${nome}`;
    return nome || cod || '';
}

export default formatUnidadeLabel;
